import { render } from "./DepartmentSelector.vue?vue&type=template&id=4ee8e2d9"
import script from "./DepartmentSelector.vue?vue&type=script&lang=js"
export * from "./DepartmentSelector.vue?vue&type=script&lang=js"

import exportComponent from "/home/nils/assessment_tool/code/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__